export default {
  props: {
    title: {
      type: Object,
    },

    paragraph: {
      type: String,
    },

    button: {
      type: Object,
    },

    placeholder: {
      type: Object,
    },

    grid: {
      type: String,
      default: 'default',
    },
  },

  computed: {
    hasImagePlaceholder() {
      return !!this.placeholder?.image
    },

    hasVideoPlaceholder() {
      return !!this.placeholder?.video
    },

    gridClass() {
      return `grid--${this.grid}`
    },
  },
}
